import React, { useState } from "react";
import FaqAccordion from "./FaqAccordion";
import styled from "styled-components";

const FaqListStyle = styled.div`
  display: flex;
  gap: 18px;
  flex-direction: column;
  padding: 75px 0;
  .title {
    color: #303030;
    font-size: 27px;
    font-weight: 600;
    line-height: 34.5px;
    margin-bottom: calc(41.5px - 18px);
  }
  .faq_columns_wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
  .faq_column{
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
    gap: 15px;
    .title {
      font-size: 20px;
      text-align: left;
      line-height: 28px;
      margin-bottom: 10px;
    }
    .faq_columns_wrapper {
      grid-template-columns: 1fr;
    }
  }
`;

const FaqList = () => {
  const [openFaqId, setOpenFaqId] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "What is Instabuild?",
      answer: "Instabuild is an Online Technology platform that connects local Buyers & Seller's in Home Improvement & building materials through out Canada by enabling fast delivery services. It also provides users the capabilities of Visualizing & Designing projects through Interactive 3D Virtual renderings."
    },
    {
      id: 2,
      question: "Who can use the platform?",
      answer: "Buyers and Sellers across Canada, including Designer's, Homeowners, Contractors, and service provider's."
    },
    {
      id: 3,
      question: "Is it free to sign up?",
      answer: "Yes, creating an account on INSTABUILD is completely free for all users."
    },
    {
      id: 4,
      question: "Can I both buy and sell from the same account?",
      answer: "No, you can switch between buyer and seller roles though the dashboards."
    },
    {
      id: 5,
      question: "How does shipping work?",
      answer: "Sellers offer scheduled pickups and delivery through Canada post, FedEx & other trusted third-party logistics partners. Choose your option at checkout. Instabuild provides both Shipping & Pickup options to consumers. We provide you the opportunity to get the materials shipped & delivered. Also, Customer can schedule pick up at desired time on independent stores."
    },
    {
      id: 6,
      question: "What types of services can I list or buy?",
      answer: "You can list home improvement, construction and building materials for buying & selling."
    },
    {
      id: 7,
      question: "What happens if there's a problem with an order?",
      answer: "You can message the seller directly or contact Instabuild support if the issue isn't resolved."
    },
    {
      id: 8,
      question: "Are payments safe on Instabuild?",
      answer: "Yes, all transactions are processed through secure, encrypted payment gateways."
    },
    {
      id: 9,
      question: "What payment methods do you accept?",
      answer: "We accept major credit and debit cards (Visa, Mastercard, Amex), Apple Pay, Google Pay and secure online checkout options. All payments are processed through trusted, encrypted gateways to ensure a safe and smooth transaction."
    },
    {
      id: 10,
      question: "How do I get paid as a seller?",
      answer: "Earnings are transferred directly to your bank account after order confirmation & return period."
    },
    {
      id: 11,
      question: "Does Instabuild charge any fees?",
      answer: "No fees for buyers. We charge seller's a commission fee for each order."
    }
  ];

  const handleToggle = (faqId) => {
    setOpenFaqId(openFaqId === faqId ? null : faqId);
  };

  // Split FAQs into two groups: first 5 and next 5
  const firstColumnFaqs = faqs.slice(0, 5);
  const secondColumnFaqs = faqs.slice(5, 10);

  return (
    <FaqListStyle className="container">
      <h2 className="title">Frequently Asked Questions</h2>
      <div className="faq_columns_wrapper">
        <div className="faq_column">
          {firstColumnFaqs.map((faq) => (
            <FaqAccordion
              key={faq.id}
              question={faq.question}
              answer={faq.answer}
              isOpen={openFaqId === faq.id}
              onToggle={() => handleToggle(faq.id)}
            />
          ))}
        </div>
      <div className="faq_column">
          {secondColumnFaqs.map((faq) => (
          <FaqAccordion
            key={faq.id}
            question={faq.question}
            answer={faq.answer}
            isOpen={openFaqId === faq.id}
            onToggle={() => handleToggle(faq.id)}
          />
        ))}
        </div>
      </div>
    </FaqListStyle>
  );
};

export default FaqList;
